import React, { useMemo, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { List, IconButton, Tooltip } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import {
    StaffListOuterContainer,
    AssignmentPanelTitleBox,
    AssignmentPanelTitle,
} from '../../../styles/CalculateMoney/AssignmentPanelStyles';
import {
    StyledListItem,
    StyledListItemText,
    StyledTypography,
} from '../../../styles/OwnerStyle/StaffComPonent/StaffListStyles';

import WorkSessionModal from './WorkSessionModalStaff';
import { useWorkSessionsContext } from '../../../context/WorkSessionsContext';
import StaffNotification from '../StaffNotification';

const AssignmentPanelStaff = ({
    staffId,
    workSessions,
    businessId,
    updateWorkSession,
    services,
    categories,
    onShowSuccess,
    notifications,
    onMarkSeen
}) => {
    const { t } = useTranslation('assignmentPanelStaff'); 
    const [openModal, setOpenModal] = useState(false);
    const [editSession, setEditSession] = useState(null);
    const { fetchWorkSessionsByStaffData } = useWorkSessionsContext();

    const mySessions = useMemo(() => {
        let sessionsArray = [];
        if (Array.isArray(workSessions)) {
            sessionsArray = workSessions;
        } else if (workSessions && Array.isArray(workSessions.$values)) {
            sessionsArray = workSessions.$values;
        }
        return sessionsArray
            .filter(ws => ws.staffId === Number(staffId))
            .filter(ws => ws.status === 'In Progress');
    }, [workSessions, staffId]);

    const handleOpenModal = (session) => {
        setEditSession(session);
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
        setEditSession(null);
    };

    return (
        <div>
            <AssignmentPanelTitleBox>
                <AssignmentPanelTitle
                    style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}
                >
                    <span>{t('assignmentPanel.myAppointments')}</span>
                    <StaffNotification notifications={notifications} onMarkSeen={onMarkSeen} />
                </AssignmentPanelTitle>
            </AssignmentPanelTitleBox>

            <StaffListOuterContainer>
                <List dense>
                    {mySessions.length === 0 && (
                        <div style={{ textAlign: 'center', color: '#aaa', margin: '30px 0' }}>
                            {t('assignmentPanel.noAppointments')}
                        </div>
                    )}
                    {mySessions.map((ws) => (
                        <StyledListItem key={ws.workSessionId}>
                            <StyledListItemText
                                primary={
                                    <StyledTypography variant="body1" style={{ fontSize: '1.1em' }}>
                                        {ws.customerName || t('assignmentPanel.appointmentWithId', { id: ws.workSessionId })}
                                    </StyledTypography>
                                }
                                secondary={
                                    <>
                                        <span style={{ color: '#1e88e5' }}>
                                            {ws.sessionStart
                                                ? new Date(ws.sessionStart).toLocaleString('de-DE', {
                                                    year: 'numeric',
                                                    month: '2-digit',
                                                    day: '2-digit',
                                                    hour: '2-digit',
                                                    minute: '2-digit',
                                                })
                                                : t('assignmentPanel.noStartTime')}
                                        </span>
                                        <br />
                                        <span style={{ fontSize: '1em', color: '#ff0000ff' }}>
                                            {ws.status}
                                        </span>
                                    </>
                                }
                            />
                            <Tooltip title={t('assignmentPanel.edit')}>
                                <IconButton color="primary" onClick={() => handleOpenModal(ws)}>
                                    <EditIcon />
                                </IconButton>
                            </Tooltip>
                        </StyledListItem>
                    ))}
                </List>
            </StaffListOuterContainer>

            <WorkSessionModal
                open={openModal}
                onClose={handleCloseModal}
                session={editSession}
                businessId={businessId}
                staffId={staffId}
                onUpdate={updateWorkSession}
                services={services}
                categories={categories}
                onShowSuccess={onShowSuccess}
                fetchMySessions={fetchWorkSessionsByStaffData}
            />
        </div>
    );
};

export default AssignmentPanelStaff;